module.exports = __webpack_public_path__ + "img/halfYellowStar.55fa641.svg";